/* LIVE RELEASE CANDIDATE. Install in the approved theme only. Never inject into checkout. */
(() => {
  if(window.__sedyClickDraft)return;window.__sedyClickDraft=true;
  document.addEventListener('click',event=>{
    if(!event.isTrusted)return;
    const link=event.target instanceof Element?event.target.closest('a[href]'):null;
    if(!link)return;
    let url;try{url=new URL(link.href,location.href)}catch{return}
    if(url.origin!==location.origin)return;
    const match=url.pathname.match(/\/products\/([^/]+)\/?$/);if(!match)return;
    // Same product page anchors/images/variant links are not product entry clicks.
    if(url.pathname===location.pathname)return;
    const position=location.pathname==='/'?'home':location.pathname.includes('/collections/')?'collection':location.pathname.includes('/search')?'search':location.pathname.includes('/products/')?'product_recommendation':'other';
    const productId=link.getAttribute('data-sedy-product-id');
    const variant=url.searchParams.get('variant');
    window.Shopify?.analytics?.publish('sedy:product_clicked',{
      productId:productId&&/^\d+$/.test(productId)?'gid://shopify/Product/'+productId:null,
      productHandle:match[1],
      variantId:variant&&/^\d+$/.test(variant)?'gid://shopify/ProductVariant/'+variant:null,
      position
    });
  },{capture:true,passive:true});
})();
